module.exports = __webpack_public_path__ + "img/banner2_9_vi.9565cdb5.png";